.display-sam-2024 a {
  cursor: pointer;
}
.display-sam-2024 .cart-status-box {
  display: flex;
}
.display-sam-2024 .cart-status-box .product-count {
  font-size: 14px;
  margin-left: 7px;
  margin-top: 1px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL2NhcnRzdGF0dXMvdmlld3MiLCJzb3VyY2VzIjpbImRpc3BsYXktc2FtLTIwMjQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFSTtFQUNJOztBQUdKO0VBQ0k7O0FBRUE7RUFDSTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuZGlzcGxheS1zYW0tMjAyNCB7XG5cbiAgICBhIHtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIH1cblxuICAgIC5jYXJ0LXN0YXR1cy1ib3gge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBcbiAgICAgICAgLnByb2R1Y3QtY291bnQge1xuICAgICAgICAgICAgZm9udC1zaXplOiAxNHB4O1xuICAgICAgICAgICAgbWFyZ2luLWxlZnQ6IDdweDtcbiAgICAgICAgICAgIG1hcmdpbi10b3A6IDFweDtcbiAgICAgICAgfVxuICAgIH1cbn0iXX0= */